import Grid from '@material-ui/core/Grid';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ClaimReimListComponent from './claim.reim.list.component';
import ClaimsReimDetails from './cliam.reim.details.component';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ClaimsReimbursement() {
  const history = useHistory();
  const query = useQuery();

  return (
    <div>
      {query.get('mode') === 'create' ? (
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '20px',
            height: '2em',
            color: '#000',
            fontSize: '18px',
            fontWeight: 600,
          }}>
          <span
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            Claim Management
          </span>
          <span>Create Claim Reimbursement</span>
        </Grid>
      ) : null}

      {(() => {
        switch (query.get('mode')) {
          case 'viewList':
            return <ClaimReimListComponent />;
          case 'create':
            return <ClaimsReimDetails />;
          default:
            history.push('/claims/claims-reimbursement?mode=viewList');
        }
      })()}
    </div>
  );
}
